import { useTranslations } from '@vocab/react';
import React from 'react';
import { Helmet } from 'react-helmet';

import translations from './.vocab';

export const AppTitle = () => {
  const { t } = useTranslations(translations);
  return <Helmet title={t('SEEK - Jobs List')} />;
};
